import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Platform } from '@ionic/angular';
import { LanguageService } from './_shared/services/language.service';
import { fromEvent } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  wakeLock: WakeLockSentinel | null = null;

  @HostListener('window:load')
  onLoad() {
    // init wakelock if supported
    if (this.isWakeLockSupported()) {
      this.requestWakeLock();

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.requestWakeLock();
        } else {
          this.releaseWakeLock();
        }
      });
    }
  }

  constructor(private platform: Platform,
              /*private splashScreen: SplashScreen,
              private statusBar: StatusBar,*/
              translate: TranslateService, languageService: LanguageService, private router: Router) {
    this.initializeApp();

    // translation config
    const lang = languageService.getLanguage(null);
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang(lang.toLowerCase());
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    languageService.useLanguage(lang);
  }

  initializeApp(): void {
    this.platform.ready().then(() => {
      //this.statusBar.styleDefault();
      //this.splashScreen.hide();
    });
  }

  ngOnInit(): void {
    // disabling browser back navigation

    // 1. blokkolja, ha más oldalról jöttünk
    history.pushState(null, '');

    fromEvent(window, 'popstate').subscribe((_) => {
      history.pushState(null, '');
      console.log('popstate');
    });

    // 2. blokkolja az egyes routok (view-k) közötti navigációt
    this.router.events
      .subscribe(event => {
        if (event instanceof NavigationStart && event.navigationTrigger === 'popstate') {
          console.log('NavigationStart');
          // Angular navigates on the last route without reloading the page
          this.router.navigateByUrl(this.router.url, {replaceUrl: true});
        }
      });
  }

  ngOnDestroy(): void {
    this.releaseWakeLock();
  }

  private isWakeLockSupported(): boolean {
    if ('wakeLock' in navigator) {
      console.log('Screen Wake Lock API supported.');

      return true;
    }

    console.log('Wake lock is not supported by this browser.');
    return false;
  }

  private requestWakeLock = async () => {
    //console.log('request wakelock');

    try {
      this.wakeLock = await navigator.wakeLock.request('screen');

      // listen for our release event
      // this.wakeLock.onrelease = function(ev) {
      //   console.log(ev);
      // }
    } catch (err) {
      // if wake lock request fails - usually system related, such as battery
      console.log(err);
    }
  }

  private releaseWakeLock(): void {
    if (this.wakeLock != null) {
      //console.log('release wakelock');

      this.wakeLock.release()
        .then(() => {
          this.wakeLock = null;
        })
    }
  }
}
